import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BiensImmobs } from 'app/models/biensImmobs';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BiensImmobsBiensImmobs {

  base_path = 'https://app.titv-store-api.com/';

  constructor(private http: HttpClient) { }

  private refreshData = new Subject<void>();
  
  get refreshNedeed() {
    return this.refreshData;
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    
    if (token) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }
    
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    }
    
    console.error('Erreur BiensImmobsService:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  // Create a new item
  createBiensImmobs(item: any): Observable<BiensImmobs> {
    const headers = this.getHeaders();
    
    return this.http.post<BiensImmobs>(
      this.base_path + 'biens/add', 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Get single BiensImmobs data by ID
  getBiensImmobs(id: any): Observable<BiensImmobs> {
    const headers = this.getHeaders();
    
    return this.http.get<BiensImmobs>(
      this.base_path + 'biens/' + id,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Get biens data
  getListBiensImmobs(): Observable<BiensImmobs[]> {
    const headers = this.getHeaders();
    
    return this.http.get<BiensImmobs[]>(
      this.base_path + 'biens/all',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Update item by id
  updateBiensImmobs(id: any, item: any): Observable<BiensImmobs> {
    const headers = this.getHeaders();
    
    return this.http.put<BiensImmobs>(
      this.base_path + 'biens/edit/' + id, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Delete item by id
  deleteBiensImmobs(id: any): Observable<any> {
    const headers = this.getHeaders();
    
    return this.http.delete<any>(
      this.base_path + 'biens/delete/' + id, 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }
  // biens-immobs.service.ts (add this method)
updateBiensOrderBatch(updates: { id: number; displayOrder: number }[]): Observable<any> {
  const headers = this.getHeaders();
  return this.http.put(
    this.base_path + 'biens/order',
    updates,
    { headers, responseType: 'text' }
  ).pipe(
    tap(() => this.refreshData.next()),
    catchError(this.handleError)
  );
}
}